import { MissionResponse } from "@app/models/Mission.ts";
import { getRequest } from "@app/services/api/api";

const MISSIONS_PATH = "missions";
export const CLIENT_PARAM = "clientName";
export const TAKIMA_EMAIL_PARAM = "takimaUserEmail";
export const ENDED_PARAM = "missionEnded";

export const useMissionService = () => {
  const fetchMissions = () => {
    return getRequest<MissionResponse[]>(`${MISSIONS_PATH}`);
  };

  return {
    fetchMissions,
  };
};
